import { TextAccountIcon } from './TextAccountIcon';

/**
 * author: Brooke Clifton
 * id 15B2BA3F-53A2-4151-9B90-20000264FE54
 * name text-account
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-account.svg
 * tags
 * - Account / User 
 */
export const BiographyIcon = TextAccountIcon;
export default BiographyIcon